import React, { useState, useEffect, useRef } from 'react';
import * as qs from 'qs';
import axios from 'axios';
import ReactPaginate from 'react-paginate';

import RenderFabric from './renderFabric';
import FabricFilter from './fabricFilter';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import FilterIcon from '../../assets/ico-filter.svg';

const baseURL = process.env.REACT_APP_API_URL + '/get_collection_material';
const ITEMS_PER_PAGE = 24;

const client = axios.create({
  baseURL
});

const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

const FabricSelector = () => {
  const [data, setData] = useState();
  const [currentId, setCurrentId] = useState();
  const [isClose, setIsClose] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [numberOfPage, setNumberOfPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    brands: [],
    types: [],
    patterns: [],
    colors: [],
    materials: [],
    all: []
  });
  
  const cancelTokenSourceRef = useRef(null);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
    wrapperRef.current.scrollIntoView();
  };

  const getData = async (params) => {
    // 新しいリクエストが開始される前に、前のリクエストをキャンセル
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel("前のリクエストが新しいリクエストによってキャンセルされました");
    }
    cancelTokenSourceRef.current = axios.CancelToken.source();

    setIsLoading(true);
    try {
      const response = await client.get(baseURL, {
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, {
            arrayFormat: 'comma',
            commaRoundTrip: false
          });
        },
        cancelToken: cancelTokenSourceRef.current.token,
      });

      setNumberOfPage(Math.ceil(parseInt(response.data.total) / 24));
      setNumberOfItems(response.data.total);
      setData(response.data.result);
      setIsLoading(false);
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.log(error);
      }
    }
  };

  const debouncedGetData = debounce(() => {
    const params = {
      fabric_brand_id: filters.brands,
      fabric_color_id: filters.colors,
      fabric_type_id: filters.types,
      fabric_pattern_id: filters.patterns,
      fabric_material_id: filters.materials,
      page: currentPage,
      perpage: ITEMS_PER_PAGE
    };
    getData(params);
  }, 500);

  useEffect(() => {
    debouncedGetData();
  }, [currentPage, filters]);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const mtmFabricSelector = document.getElementById('mtm-fabric-selector');
    if (mtmFabricSelector) {
        const headDescriptionHTML = mtmFabricSelector.dataset.headDescriptionHtml;
        const targetElement = document.querySelector('.section-header__sub-description');
        if (targetElement) {
            targetElement.innerHTML = headDescriptionHTML;
        }
    }
  }, []);

  return (
    <div>
      <header className="section-header">
        <h1 className="section-header__title mt-5 pt-5">Fabric Collection</h1>
        <div className="section-header__sub-description mt-3"></div>
      </header>
      <div id="CollectionAjaxResult">
        <div className="mtm-fabric__container px-0">
          <div ref={wrapperRef}></div>
          <p className="mb-5 collection__item-no pc_only">
            {numberOfItems} {numberOfItems > 1 ? 'products' : 'product'}
          </p>
          <div className="row">
            <div className="col-lg-2 col-12">
              <div className="row sp_only">
                <div className="col-sm-3 col-6 d-flex justify-content-center">
                  <a
                    className="border w-100 py-1 ps-1 d-flex align-items-center"
                    data-bs-toggle="offcanvas"
                    href="#filterOffCanvas"
                    role="button"
                    aria-controls="filterOffCanvas"
                  >
                    <img src={FilterIcon} />
                    <span className="ms-1">Filter</span>
                  </a>
                </div>
              </div>
              <FabricFilter
                setFilters={setFilters}
                filters={filters}
                setCurrentPage={setCurrentPage}
              />
              <p className="mt-3 text-center collection__item-no sp_only">
                {numberOfItems} {numberOfItems > 1 ? 'products' : 'product'}
              </p>
            </div>
            <div className="col-lg-10 col-12 mb-4">
              {isLoading ? (
                <div>Loading...</div>
              ) : (
                <div className="row">
                  {data?.map((option) => (
                    <RenderFabric
                      option={option}
                      key={option.product_number}
                      isClose={isClose}
                      setIsClose={setIsClose}
                      currentId={currentId}
                      setCurrentId={setCurrentId}
                    />
                  ))}
                </div>
              )}
              <ReactPaginate
                containerClassName="collection-paginate my-5 mx-0"
                breakLabel="..."
                nextLabel=">"
                nextClassName="collection-paginate__arrow"
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                pageCount={numberOfPage}
                previousLabel="<"
                previousClassName="collection-paginate__arrow"
                renderOnZeroPageCount={null}
                onPageChange={handlePageClick}
                forcePage={currentPage - 1}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FabricSelector;
